import { VBadge } from '@vrzl/ui';
import { useSetAtom } from 'jotai';

import { documentDialogAtom } from '@/domains/documents';

type ChatDocumentTagsProps = {
  documents: { id: string; name: string }[];
  eventId: string;
};

export function ChatDocumentTags({ documents, eventId }: ChatDocumentTagsProps) {
  const setDocDialog = useSetAtom(documentDialogAtom);

  if (documents.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 rounded-lg border border-border bg-muted/40 p-3">
      {documents.map((doc) => (
        <button
          key={doc.id}
          type="button"
          onClick={() => setDocDialog({ eventId, docId: doc.id })}
        >
          <VBadge color="neutral" className="hover:underline">
            {doc.name}
          </VBadge>
        </button>
      ))}
    </div>
  );
}
